// ─────────────────────────────────────────────────────────────────────────
// Hearth — loads SRD metadata once and shares it via context. The character
// builder, compendium, and several panels rely on it.
// ─────────────────────────────────────────────────────────────────────────
import { createContext, useContext } from "react";
import type { SrdMeta } from "../lib/types";

export interface MetaContextValue {
  meta: SrdMeta | null;
  loading: boolean;
  error: string | null;
  llm: boolean;
  reload: () => void;
}

export const MetaContext = createContext<MetaContextValue>({
  meta: null,
  loading: true,
  error: null,
  llm: false,
  reload: () => {},
});

export function useMeta(): MetaContextValue {
  return useContext(MetaContext);
}
